<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
		<div class="widget-heading">
		  <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
			<div>
			  <h4 class="mb-1">
				Aktualne komunikaty bezpieczeństwa CERT Polska
			  </h4>
			</div>

			<div class="d-flex align-items-center gap-2 ms-auto">
			  <button type="button" class="btn btn-outline-primary" @click="loadFeed" :disabled="loading">
				<i class="bi" :class="loading
				  ? 'bi-arrow-repeat spin'
				  : 'bi-arrow-clockwise'"></i>
				<span class="ms-1">
				  Odśwież
				</span>
			  </button>
			</div>
		  </div>
		</div>
        <div class="widget-content">
          <div v-if="loading" class="cert-state">
            <div class="spinner-border text-primary"></div>
            <div class="mt-3">
              Pobieranie komunikatów CERT Polska...
            </div>
          </div>
          <div v-else-if="error" class="alert alert-danger d-flex align-items-start gap-3">
            <i class="bi bi-exclamation-triangle-fill fs-4"></i>
            <div>
              <strong>Nie udało się pobrać komunikatów.</strong>
              <div class="mt-1">
                {{ error }}
              </div>
              <button type="button" class="btn btn-sm btn-danger mt-3" @click="loadFeed">
                Spróbuj ponownie
              </button>
            </div>
          </div>
          <div v-else-if="items.length === 0" class="cert-state">
            <i class="bi bi-inbox fs-1 text-muted"></i>
            <div class="mt-3 text-muted">
              Brak komunikatów.
            </div>
          </div>
          <div v-else class="cert-list">
            <article v-for="(item, index) in items" :key="item.guid || item.link || index" class="cert-card"
              :class="{ 'is-open': openedIndex === index }">
              <button type="button" class="cert-card-header" @click="toggleItem(index)">
                <div class="cert-card-main">
                  <div class="cert-meta">
                    <span v-if="item.pub_date" class="cert-date">
                      <i class="bi bi-calendar3"></i>

                      {{ formatDate(item.pub_date) }}
                    </span>
                  </div>
                  <h4 class="cert-title">
                    {{ item.title }}
                  </h4>
                </div>
                <div class="cert-arrow">
                  <i class="bi" :class="openedIndex === index
                    ? 'bi-chevron-up'
                    : 'bi-chevron-down'"></i>
                </div>
              </button>
              <transition name="cert-expand">
                <div v-if="openedIndex === index" class="cert-card-content">
                  <div class="cert-description" v-html="item.description"></div>
                </div>
              </transition>
            </article>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from 'axios'

export default {
  name: 'CertRssIndex',

  components: {
    AppLayout,
  },

  data() {
    return {
      items: [],
      loading: false,
      error: null,
      openedIndex: null,
    }
  },

  mounted() {
    this.loadFeed()
  },

  methods: {
    async loadFeed() {
      this.loading = true
      this.error = null

      try {
        const response = await axios.get(
          route('cert.rss')
        )

        this.items = response.data.items || []

        // Automatycznie otwórz pierwszy komunikat
        if (this.items.length > 0 && this.openedIndex === null) {
          this.openedIndex = 0
        }
      } catch (error) {
        console.error('CERT RSS error:', error)

        if (error.response?.data?.message) {
          this.error = error.response.data.message
        } else {
          this.error = 'Nie udało się pobrać komunikatów CERT Polska.'
        }
      } finally {
        this.loading = false
      }
    },

    toggleItem(index) {
      if (this.openedIndex === index) {
        this.openedIndex = null
      } else {
        this.openedIndex = index
      }
    },

    formatDate(date) {
      if (!date) {
        return ''
      }

      const parsed = new Date(date)

      if (Number.isNaN(parsed.getTime())) {
        return date
      }

      return new Intl.DateTimeFormat('pl-PL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(parsed)
    },
  },
}
</script>

<style scoped>
.cert-badge {
  display: inline-flex;
  align-items: center;
  padding: 7px 12px;
  border-radius: 8px;
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  font-size: 13px;
  font-weight: 600;
}

.cert-state {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #6c757d;
  text-align: center;
}

.cert-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cert-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

.cert-card:hover {
  border-color: #cfd5dc;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.cert-card.is-open {
  border-color: rgba(13, 110, 253, 0.35);
}

.cert-card-header {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  text-align: left;
  cursor: pointer;
}

.cert-card-main {
  min-width: 0;
  flex: 1;
}

.cert-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}

.cert-category {
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 6px;
  background: #f0f4f8;
  color: #59636e;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.cert-date {
  color: #8a929a;
  font-size: 12px;
}

.cert-date i {
  margin-right: 4px;
}

.cert-title {
  margin: 0;
  color: #20252b;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
}

.cert-arrow {
  width: 36px;
  height: 36px;
  min-width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f5f7f9;
  color: #68717b;
}

.cert-card-content {
  padding: 0 20px 20px;
}

.cert-description {
  padding-top: 5px;
  color: #3d444c;
  font-size: 14px;
  line-height: 1.7;
  overflow-x: auto;
}

.cert-description :deep(p) {
  margin-bottom: 14px;
}

.cert-description :deep(a) {
  color: #0d6efd;
  text-decoration: underline;
}

.cert-description :deep(img) {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 18px auto;
  border-radius: 8px;
}

.cert-description :deep(table) {
  width: 100%;
  max-width: 100%;
  margin: 18px 0;
  border-collapse: collapse;
  overflow: hidden;
}

.cert-description :deep(th),
.cert-description :deep(td) {
  padding: 8px;
  border: 1px solid #dee2e6;
  text-align: left;
}

.cert-description :deep(hr) {
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #e5e7eb;
}

.cert-description :deep(ul),
.cert-description :deep(ol) {
  padding-left: 24px;
}

.cert-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #edf0f2;
}

.cert-expand-enter-active,
.cert-expand-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.cert-expand-enter-from,
.cert-expand-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.spin {
  animation: cert-spin 1s linear infinite;
}

@keyframes cert-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 767px) {
  .cert-card-header {
    padding: 16px;
  }

  .cert-card-content {
    padding: 0 16px 16px;
  }

  .cert-title {
    font-size: 15px;
  }

  .cert-footer {
    justify-content: stretch;
  }

  .cert-footer .btn {
    width: 100%;
  }
}
</style>